import React from 'react';
function DeleteIcon() {
return (
    <>
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 48 48" aria-labelledby="deleteIconTitle" role="img" >
            <title id="deleteIconTitle">Delete Icon</title>
            <path className="cls-1" fill="#3B82EE" d="M36,44H12a3,3,0,0,1-3-3V12a1,1,0,0,1,1-1H38a1,1,0,0,1,1,1V41A3,3,0,0,1,36,44ZM11,13V41a1,1,0,0,0,1,1H36a1,1,0,0,0,1-1V13Z" />
            <path className="cls-1" fill="#3B82EE" d="M43,13H5a1,1,0,0,1,0-2H43a1,1,0,0,1,0,2Z" />
            <path className="cls-1" fill="#3B82EE" d="M17,35a1,1,0,0,1-1-1V20a1,1,0,0,1,2,0V34A1,1,0,0,1,17,35Z" />
            <path className="cls-1" fill="#3B82EE" d="M31,35a1,1,0,0,1-1-1V20a1,1,0,0,1,2,0V34A1,1,0,0,1,31,35Z" />
            <path  className="cls-1" fill="#3B82EE" d="M24,37a1,1,0,0,1-1-1V18a1,1,0,0,1,2,0V36A1,1,0,0,1,24,37Z" />
            <path className="cls-1" fill="#3B82EE"  d="M33,13H15a1,1,0,0,1-1-1V7a3,3,0,0,1,3-3H31a3,3,0,0,1,3,3v5A1,1,0,0,1,33,13ZM16,11H32V7a1,1,0,0,0-1-1H17a1,1,0,0,0-1,1Z" />
        </svg>
    </>
);
}
export default DeleteIcon;